import { css } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
export var footerSection = /*#__PURE__*/css("display:none;text-align:center;margin-top:15px;", media('>=tablet'), "{display:block;}");
export var companyName = {
  name: "xydou1",
  styles: "margin-top:60px;line-height:16px;svg{width:94.7px;height:16px;margin-right:28px;vertical-align:middle;}"
};
export var companyAllhomes = /*#__PURE__*/css("font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";color:", colour.neutral800, ";text-decoration:none;");